import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {JbJobRunService} from '../../../service/api/jb-job-run.service';

@Component({
    selector: 'jb-job-execution-overlap-component',
    templateUrl: 'jb-job-execution-overlap.component.html',
    styleUrls: ['jb-job-execution-overlap.component.scss'],
    standalone: false
})
export class JbJobExecutionOverlapComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    jobWindows : any; // Replace with your actual response
    selectedWindow: any = null;
    selectedJob: any = null;
    showJobInstanceSideBar: boolean = false;

    constructor(
        protected jobRunService: JbJobRunService) {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {

        const now = new Date();
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1); // first day of current month at 00:00:00;
        this.fetchJobSummary(startOfMonth, now);
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    handleDateChange(object: { startDate: string, endDate: string }) {
        const start = new Date(object.startDate);
        const end = new Date(object.endDate);
        this.selectedWindow = null;
        this.fetchJobSummary(start, end);
    }

    fetchJobSummary(startTime: Date, endTime: Date): void {
        if (this.busy) {
            return;
        }

        this.busy = true;

        this.jobRunService.getJobSummary(startTime, endTime).subscribe({
            next: (data) => {
                this.jobWindows = data
                    .filter(window => window.count > 1)
                    .sort((a, b) => b.count - a.count)
                    .map((window, index) => ({ ...window, id: index })); // assign index as id

                this.busy = false;
                this.refreshComponent();
            },
            error: (err) => {
                console.error('Failed to fetch job summary', err);
                this.busy = false;
                this.refreshComponent();
            }
        });
    }

    formatDuration(duration: string): string {
        // ISO-8601 duration like 'PT6M30.3504325S'
        const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+\.?\d*)S)?/);
        if (!match) return duration;

        const [, h, m, s] = match;
        const parts = [];
        if (h) parts.push(`${h}h`);
        if (m) parts.push(`${m}m`);
        if (s) parts.push(`${parseFloat(s).toFixed(2)}s`);
        return parts.join(' ');
    }

    onWindowSelect(data: any) {
        this.selectedWindow = data;
    }
    onJobSelect(job){
        this.selectedJob = job;
        this.showJobInstanceSideBar = true;
    }
    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes['id']) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
